<template>
  <div
    v-if="$store.state.loading"
    id="waitingLoad"
    class="absolute loading top-0 right-0 left-0 bottom-0 outline-0"
  >
    <div
      role="presentation"
      class="overlay z-20 w-full h-full bg-black-full"
    ></div>

    <img
      class="
        animate-spin
        fixed
        z-30
        h-16
        top-0
        bottom-0
        left-0
        right-0
        m-auto
        pointer-events-none
      "
      :src="$S3AssetUrl('suf/home/photo-pass-logo.png')"
      alt="logo photo"
    />

    <p
      class="
        text
        animate-pulse
        fixed
        z-30
        flex
        items-center
        justify-center
        m-auto
        text-white
        w-full
        top-28
        bottom-0
        pointer-events-none
      "
    >
      {{ $t('messages.wait_moment') }}
    </p>
  </div>
</template>

<script>

export default {
  data: () => ({}),
  methods: {},
  created() {},
  mounted() {},
};
</script>
